export const SMALLCHART_INITIAL = 'smallchart_initial';
